export const parseNumericHumanDate = (stringDate: string): Date | null => {
	const parts = stringDate.match(/^(\d{1,2})\.[\xA0 ]?(\d{1,2})\.[\xA0 ]?(\d{4})$/);
	if (parts === null) {
		return null;
	}

	const year = Number(parts[3]);
	const month = Number(parts[2]) - 1;
	const day = Number(parts[1]);
	const date = new Date(year, month, day);

	return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day ? date : null;
};
